module.exports = __webpack_public_path__ + "static/media/dog.10c86eb3.png";